var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClippy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.96151 2.51283C6.0925 2.90579 5.88013 3.33053 5.48717 3.46151L4.67094 3.73359C4.56886 3.76762 4.5 3.86315 4.5 3.97076V21.25C4.5 21.3881 4.61193 21.5 4.75 21.5H19.25C19.3881 21.5 19.5 21.3881 19.5 21.25V3.97076C19.5 3.86315 19.4311 3.76762 19.3291 3.73359L18.5128 3.46151C18.1199 3.33053 17.9075 2.90579 18.0385 2.51283C18.1695 2.11987 18.5942 1.9075 18.9872 2.03849L19.8034 2.31056C20.518 2.54876 21 3.21751 21 3.97076V21.25C21 22.2165 20.2165 23 19.25 23H4.75C3.7835 23 3 22.2165 3 21.25V3.97076C3 3.2175 3.482 2.54876 4.1966 2.31056L5.01283 2.03849C5.40579 1.9075 5.83053 2.11987 5.96151 2.51283Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1.75C7 0.783502 7.7835 0 8.75 0H15.25C16.2165 0 17 0.783502 17 1.75V3.25C17 4.2165 16.2165 5 15.25 5H8.75C7.7835 5 7 4.2165 7 3.25V1.75ZM8.75 1.5C8.61193 1.5 8.5 1.61193 8.5 1.75V3.25C8.5 3.38807 8.61193 3.5 8.75 3.5H15.25C15.3881 3.5 15.5 3.38807 15.5 3.25V1.75C15.5 1.61193 15.3881 1.5 15.25 1.5H8.75Z",
    fill: "#111111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClippy);
export default __webpack_public_path__ + "static/media/clippy.c8ec4cbc.svg";
export { ForwardRef as ReactComponent };